import React from 'react'
import { useStyles } from './styles.js'

const UserLogo = () => {
  const classes = useStyles()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      {/* <defs>
            <style>.a,.b{fill:none;}.a{stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.c{fill:#fff;opacity:0.64;}</style>
            </defs> to be moved to styles.js*/}
      <g transform="translate(-0.4)">
        <circle
          class="a"
          fill="none"
          stroke="#FFF"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="2px"
          cx="15"
          cy="15"
          r="15"
          transform="translate(1.4 1)"
        />
        <rect
          class="b"
          fill="none"
          width="32"
          height="32"
          transform="translate(0.4)"
        />
        <path
          class="c"
          fill="#FFF"
          opacity="0.64"
          d="M22.18,25.28a26.282,26.282,0,0,1-.057-2.677A5.239,5.239,0,0,0,23.559,19.5c.365-.03.94-.386,1.109-1.792a1.312,1.312,0,0,0-.49-1.313c.594-1.786,1.827-7.311-2.281-7.882-.423-.743-1.506-1.118-2.913-1.118-5.629.1-6.308,4.251-5.074,9a1.315,1.315,0,0,0-.49,1.313c.169,1.406.744,1.762,1.109,1.792A5.228,5.228,0,0,0,16,22.6a26.287,26.287,0,0,1-.058,2.677c-.8,2.155-4.919,2.324-7.294,4.4A15.545,15.545,0,0,0,19.4,33.972c4.247,0,9.239-3.353,10.07-4.268C27.111,27.606,22.984,27.443,22.18,25.28Z"
          transform="translate(-3.149 -2.431)"
        />
      </g>
    </svg>
  )
}
export default UserLogo
